/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type UseQueryResult } from '@tanstack/react-query';
import type { BatchedReviewsForAnalytics, ReviewStatisticResponse } from '../interface/types';
import { reviewAnalyticsSelector } from '@/features/shelf/utils/reviewAnalyticsSelector';

export const combineReviewStatisticsForAnalytics = (
  results: Array<UseQueryResult<ReviewStatisticResponse[], Error>>,
): BatchedReviewsForAnalytics => {
  return results.reduce<BatchedReviewsForAnalytics>(
    (acc, result) => {
      acc.rawQueryResults.push(result);

      acc.isPending = acc.isPending || result.isPending;
      acc.isFetching = acc.isFetching || result.isFetching;
      acc.isError = acc.isError || result.isError;

      if (!result.data) {
        return acc;
      }
      const analyticsItem = reviewAnalyticsSelector(result.data);

      const { productAverageRating, productReviewCount } = analyticsItem;
      acc.combinedData.productAverageRating.push(...productAverageRating);
      acc.combinedData.productReviewCount.push(...productReviewCount);

      return acc;
    },
    {
      isPending: false,
      isFetching: false,
      isError: false,
      combinedData: { productAverageRating: [], productReviewCount: [] },
      rawQueryResults: [],
    },
  );
};
